import { render } from "./EditorDetail.vue?vue&type=template&id=55de2cae&scoped=true"
import script from "./EditorDetail.vue?vue&type=script&lang=js"
export * from "./EditorDetail.vue?vue&type=script&lang=js"

import "./EditorDetail.vue?vue&type=style&index=0&id=55de2cae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55de2cae"]])

export default __exports__